export default __webpack_public_path__ + "static/media/gradient-background.b5dbc90a.png";